<template>
  <div class="text-center">
    <v-dialog :value="dialog" width="640" persistent no-click-animation>
      <v-card>
        <v-card-title class="headline"
          :style="`border-bottom: 10px solid ${client.color};`">
          {{ title }}
        </v-card-title>

        <v-card-text v-if="client">
          <v-container row multiline>
            <v-flex xs10>
              <v-img v-if="isUpdating || isRemoving" ref="logo" :src="url ? url : `${apiUrl}/storage/${client.logo}`"></v-img>
            </v-flex>
            <v-flex sm10>
              <v-file-input accept="image/*" label="Select logo image." v-model="file"></v-file-input>
            </v-flex>
            <v-flex sm2 align-self-end py-1 class="d-none">
              <v-btn :disabled="!file" color="secondary" @click="uploadLogo">
                <v-icon>
                  fa-upload
                </v-icon>
              </v-btn>
            </v-flex>
            <v-flex xs10>
              <v-form ref="frmRegister">
                <v-text-field :disabled="isRemoving" required v-model="client.name" label="Client Name"></v-text-field>
              </v-form>
            </v-flex>
            <v-flex xs2>
              <v-btn block @click="showColor = !showColor" :color="client.color">
                <v-icon>
                  fa-palette
                </v-icon>
              </v-btn>
            </v-flex>
            <v-flex xs12 v-if="showWarning && isUpdating">
              <p class="orange--text mt-n4">Warning: Change this field will break the permalink to existing clients</p>
            </v-flex>
            <v-flex xs6>
              <div v-show="showColor">
                <v-color-picker v-model="color" class="ma-2"></v-color-picker>
              </div>
            </v-flex>
            <v-flex xs12>
              <h3 class="text-overline">Current Games</h3>
              <p class="text-caption">Current games increment to the next in sequence <b>at midnight daily</b>.<br/>
              If the next in sequence isn't found the cycle repeats.<br/>
              Note: should we have provision to send an email alert when the next in sequence isn't present.</p>
            </v-flex>
            <v-flex xs12>
              <h3 class="text-overline">Jumble Word</h3>
              <!-- Current Game Permalink -->
              <div v-if="!showWarning && isUpdating">
                <p>Current Game: <a target="_blank" :href="`${jumblewordsUrl}/latest/${client.slug}`">https:{{jumblewordsUrl}}/latest/{{client.slug}}</a></p>
              </div>
              <v-combobox
                :items="jByClient(client.id)"
                item-text="name"
                item-value="id"
                v-model="currentJ"
                label="Current Jumble Word"
                clearable></v-combobox>
              <!-- Game History List -->
              <p>Game List: <a target="_blank" :href="`${jumblewordsUrl}/listgames/${client.slug}`">https:{{jumblewordsUrl}}/listgames/{{client.slug}}</a></p>
              <v-text-field
                type="number"
                placeholder="5"
                v-model="previousDaysJ"
                label="How many previous days should be listed?">
              </v-text-field>
              <p>Days Left: {{ daysLeft.daysLeftJ }}</p>
            </v-flex>

            <v-flex xs12>
              <h3 class="text-overline">Target Time</h3>
              <!-- Current Game Permalink -->
              <div v-if="!showWarning && isUpdating">
                <p>Current Game: <a target="_blank" :href="`${targettimesUrl}/latest/${client.slug}`">https:{{targettimesUrl}}/latest/{{client.slug}}</a></p>
              </div>
              <v-combobox
                :items="ttByClient(client.id)"
                item-text="name"
                item-value="id"
                v-model="currentTT"
                label="Current Target Time"
                clearable></v-combobox>
              <!-- Game History List -->
              <p>Game List: <a target="_blank" :href="`${targettimesUrl}/listgames/${client.slug}`">https:{{targettimesUrl}}/listgames/{{client.slug}}</a></p>
              <v-text-field
                type="number"
                placeholder="5"
                v-model="previousDaysTT"
                label="How many previous days should be listed?">
              </v-text-field>
              <p>Days Left: {{ daysLeft.daysLeftTT }}</p>
            </v-flex>

            <v-flex xs12>
              <h3 class="text-overline">Alfakodo</h3>
              <div v-if="!showWarning && isUpdating">
                <p>Current Game: <a target="_blank" :href="`${alfakodosUrl}/latest/${client.slug}`">https:{{alfakodosUrl}}/latest/{{client.slug}}</a></p>
              </div>
              <v-combobox
                :items="akByClient(client.id)"
                item-text="name"
                item-value="id"
                v-model="currentAK"
                label="Current Alfakodo"
                clearable></v-combobox>
              <p>Game List: <a target="_blank" :href="`${alfakodosUrl}/listgames/${client.slug}`">https:{{alfakodosUrl}}/listgames/{{client.slug}}</a></p>
              <v-text-field
                type="number"
                placeholder="5"
                v-model="previousDaysAK"
                label="How many previous days should be listed?">
              </v-text-field>
              <p>Days Left: {{ daysLeft.daysLeftAK }}</p>
            </v-flex>

            <v-flex xs12>
              <h3 v-if="client.__meta__">Games associated with client:
                {{ client.__meta__.alfakodos_count + client.__meta__.targettimes_count }}</h3>
            </v-flex>
            <v-flex xs6>
              <p>Last updated: {{ client.updated_at | ago }}</p>
            </v-flex>
            <v-flex xs6>
              <p>Date created: {{ client.created_at | ago }}</p>
            </v-flex>
            <v-flex v-if="isRemoving">
              <h3 class="red--text">Really remove {{ client.name }}? This cannot be undone.</h3>
            </v-flex>
          </v-container>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn v-if="isUpdating" color="info" @click="updateClient">
            Update client
          </v-btn>
          <v-btn v-else-if="isRemoving" color="error" @click="removeClient">
            Remove client
          </v-btn>
          <v-btn v-else color="primary" @click="createClient">
            {{ title }}
          </v-btn>
          <v-btn :color="( isRemoving? 'success' : 'error' )" @click="$emit('cancel')">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import _ from 'lodash'
const defaultColor = '#2FA4E4';
  export default {
    data() {
      return {
        apiUrl: process.env.VUE_APP_API_URL,
        targettimesUrl: process.env.VUE_APP_TARGETTIME_URL,
        jumblewordsUrl: process.env.VUE_APP_JUMBLEWORD_URL,
        alfakodosUrl: process.env.VUE_APP_ALFAKODO4_URL,
        color: this.client.color || defaultColor,
        showColor: false,
        file: null,
        errors: [],
        url: "",
        fileNameTmp: "",
        clientNameTmp: _.cloneDeep(this.client.name),
        showWarning: false,
        daysLeft: {}
      }
    },
    computed: {
      ...mapGetters('clients', ['clientOptions']),
      ...mapGetters('targettimes', {ttByClient: 'byClient'}),
      ...mapGetters('alfakodos', {akByClient: 'byClient'}),
      ...mapGetters('jumblewords', {jByClient: 'byClient'}),
      ...mapState('targettimes', ['targettimes']),
      currentAK: {
        get: function() {
          let optionAK = _.find(this.client.options, "currentAK")
          let currentAK = null;
          if(optionAK)
            currentAK = optionAK.currentAK
          return currentAK
        },
        set: function(event) {
          let currentAK = _.find(this.client.options, "currentAK")
          if(currentAK) {
            currentAK["currentAK"] = event.name
          } else {
            this.client.options.push({
              "currentAK": event.name
            })
          }
        }
      },
      currentTT: {
        get: function() {
          let op = _.find(this.client.options, "currentTT")
          let current = null;
          if(op)
            current = op.currentTT
          return current
        },
        set: function(event) {
          let currentTT = _.find(this.client.options, "currentTT")
          if(currentTT) {
            currentTT["currentTT"] = event.name
          } else {
            this.client.options.push({
              "currentTT": event.name
            })
          }
        }
      },
      currentJ: {
        get: function() {
          let op = _.find(this.client.options, "currentJ")
          let current = null;
          if(op)
            current = op.currentJ
          return current
        },
        set: function(event) {
          let currentJ = _.find(this.client.options, "currentJ")
          if(currentJ) {
            currentJ["currentJ"] = event.name
          } else {
            this.client.options.push({
              "currentJ": event.name
            })
          }
        }
      },
      previousDaysTT: {
        get: function() {
          let op = _.find(this.client.options, "previousDaysTT")
          let current = null;
          if(op)
            current = op.previousDaysTT
          return current
        },
        set: function(event) {
          let previousDaysTT = _.find(this.client.options, "previousDaysTT")
          if(previousDaysTT) {
            previousDaysTT["previousDaysTT"] = parseInt(event)
          } else {
            this.client.options.push({
              "previousDaysTT": parseInt(event)
            })
          }
        }
      },
      previousDaysJ: {
        get: function() {
          let op = _.find(this.client.options, "previousDaysJ")
          let current = null;
          if(op)
            current = op.previousDaysJ
          return current
        },
        set: function(event) {
          let previousDaysJ = _.find(this.client.options, "previousDaysJ")
          if(previousDaysJ) {
            previousDaysJ["previousDaysJ"] = parseInt(event)
          } else {
            this.client.options.push({
              "previousDaysJ": parseInt(event)
            })
          }
        }
      },
      previousDaysAK: {
        get: function() {
          let op = _.find(this.client.options, "previousDaysAK")
          let current = null;
          if(op)
            current = op.previousDaysAK
          return current
        },
        set: function(event) {
          let previousDaysAK = _.find(this.client.options, "previousDaysAK")
          if(previousDaysAK) {
            previousDaysAK["previousDaysAK"] = parseInt(event)
          } else {
            this.client.options.push({
              "previousDaysAK": parseInt(event)
            })
          }
        }
      },
      title: {
        get: function(){
          return (this.isUpdating ? "Update" : this.isRemoving ? "Remove" : "Create" ) + " " + (this.isUpdating || this.isRemoving ? this.client.name : "client");
        }
      }  
    },
    watch: {
      color: function () {
        this.client.color = this.color
      },
      file: function () {
        this.fileNameTmp = this.file.name
        this.url = URL.createObjectURL(this.file);
      },
      'client.name': function() {
        this.showWarning = this.clientNameTmp !== this.client.name
      },
      dialog: async function(value) {
        if(value){
          const response = await this.$axios.get('daysleft?client=' + value.id);
          this.daysLeft = response.data;
        }
      }
    },
    props: ["dialog", "client", "isUpdating", "isRemoving"],
    methods: {
      addOption() {
        if(!this.client.options) {
          this.client.options = []
        }
        this.client.options.push({
          "name": "",
          "value": ""
        })
      },
      uploadLogo() {
        if (this.file) {
          var data = new FormData()
          data.append("file", this.file, this.file.name);
          data.append("client_id", this.client.id)
          var that = this
          this.$axios({
            method: 'post',
            url: 'storage',
            data: data,
            headers: {
              'Content-Type': 'multipart/form-data'
            },
            onUploadProgress: function (event) {
              that.uploadedPercent = (event.loaded / event.total) * 100
            }
          }).then(res => {
            this.client.logo = res.data[0].name
            if (res.data.message) {
              this.$toastr.e(res.data, res.data)
            } else {
              res.data.forEach(file => {
                this.$toastr.s('Uploaded & saved: ' + file.name)
              })
            }
            this.uploadedPercent = 0
            this.logoCallback()
          }).catch(err => {
            this.$toastr.e(err)
            this.uploadedPercent = 0
          })
        }
      },
      createClient() {
        if (this.validateClient()) {
          if (this.$refs.frmRegister.validate()) {
            if(!this.client.color)
              this.client.color = defaultColor;
            this.client.logo = this.fileNameTmp
            this.client.options = []
            this.$store.dispatch('clients/createClient', this.client)
            this.uploadLogo()
            //Reset form
            this.file = null
            this.$emit('cancel', this.url, this.client.name)
          }
        }
      },
      updateClient() {
        if (this.validateClient()) {
          if (this.$refs.frmRegister.validate()) {
            this.client.logo = this.fileNameTmp ? this.fileNameTmp : this.client.logo
            this.$store.dispatch('clients/updateClient', this.client)
            this.clientNameTmp = this.client.name
            this.showWarning = this.clientNameTmp !== this.client.name
            this.uploadLogo()
            this.$emit('cancel')
          }
        }
      },
      validateClient() {
        this.errors = []

        if (!this.file && !this.isUpdating)
          this.errors.push("Logo is required")

        if (!this.client.name)
          this.errors.push("Client Name is required")

        if (this.errors.length) {
          for (var key in this.errors) {
            this.$toastr.e(this.errors[key])
          }
          return false
        }

        return true
      },
      removeClient() {
        this.$store.dispatch('clients/removeClient', this.client)
        this.$emit('cancel')
      },
      logoCallback() {
        this.$emit('callback', this.url, this.client.id)
      }
    }
  }
</script>